import { GridItem } from '@bnnvara/grids';
import { Text } from '@bnnvara/typography';
import React from 'react';

const ComposableText = (props) => (
  <GridItem
    columnStartSm="1"
    columnEndSm="span 12"
    columnStartMd="2"
    columnEndMd="span 10"
    columnStartLg="3"
    columnEndLg="11"
    as={Text}
    {...props}
    html
  />
);

export default ComposableText;
